import { View, StyleSheet, Text, Dimensions } from "react-native";
import {
  contest_events_empty,
  leaderboard_empty,
  markets_empty,
  portfolio_empty,
} from "../utils/images";
import React from "react";
import FastImage from "../common/FastImage";
import Colors from "../assets/Color/Colors";
import { globalFontStyle } from "../assets";
import { globalImport } from "../common/globalImports";
import FormTextLabel from "./FormTextLabel";
import { globalConfigurableData } from "../utils/globalConstant";

export default function NoMarket(props) {
  const styles = StyleSheet.create({
    img: {
      width: globalImport?.isWeb ? 250 : 200,
      height: globalImport?.isWeb ? 250 : 200,
      marginTop: 80,
      alignContent: "center",
      justifyContent: "center",
    },
  });

  const data =
    props?.source === "home"
      ? {
          title: "Off Market hours",
          message:
            "We’re currently creating new markets exclusively for you. Please check back later.",
          img: globalConfigurableData.markets_empty(),
        }
      : props?.source === "portfolio"
      ? {
          title: "Start trading now & earn handsome profits instantly",
          message: "",
          img: globalConfigurableData.portfolio_empty(),
        }
      : props?.source === "contest"
      ? {
          title: "Contests will appear here",
          message:
            "We’re currently creating new contests exclusively for you. Please check back later.",
          img: globalConfigurableData.markets_empty(),
        }
      : props?.source === "contest_events"
      ? {
          title: "",
          message: "No live events at the moment. Please check after sometime.",
          img: contest_events_empty(),
        }
      : props?.source === "contest_closed"
      ? {
          title: "",
          message: "No closed position. Your trade summary will appear here.",
          img: contest_events_empty(),
        }
      : props?.source === "contest_leaderboard"
      ? {
          title: "",
          message:
            "The leaderboard will be visible on this page once the contest starts.",
          img: leaderboard_empty(),
        }
      : props?.source === "contest_portfolio"
      ? {
          title: "",
          message: "No active position.",
          img: portfolio_empty(),
        }
      : "";

  return (
    <>
      <View
        style={{
          flex: !props?.innerContestCondition ? 1 : 0,
            backgroundColor: globalConfigurableData.globalThemeColor,
          // height: ScreenHeight,
          alignItems: "center",
          justifyContent: "center",
          paddingHorizontal: 40,
        }}
      >
        {!props?.innerContestCondition ? (
          <FastImage style={styles.img} source={data?.img} />
        ) : (
          <View style={{ height: 40 }} />
        )}
        <FormTextLabel
          labelStyles={{
            ...globalFontStyle.appFontTitle,
            marginTop: 20,
            textAlign: "center",
              color: globalConfigurableData.primaryTextColor1,
          }}
          label={data?.title}
        />
        {data?.message ? (
          <FormTextLabel
            labelStyles={{
              ...globalFontStyle.appFontBody,
              marginTop: 5,
              textAlign: "center",
                color: globalConfigurableData.secondaryTextColor1,
            }}
            label={data?.message}
          />
        ) : null}
      </View>
    </>
  );
}
